/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class AccordionControl extends React.Component {
    render() {
        let accordionClass = this.props.accordionOpen
            ? 'fa fa-caret-down'
            : 'fa fa-caret-right';

        return (<div className="item-row-cell accordion-control">
            <i className={accordionClass} aria-hidden="true"></i>
        </div>);

    }

};

AccordionControl.defaultProps = {
    accordionOpen: false
}

export default AccordionControl;
